// extracted by mini-css-extract-plugin
export default {"anchor":"anchor-1MIwyf"};